import Axios from "axios";
import React, { Component, PureComponent } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    useRouteMatch,
} from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import Func from "../../../functions";

const styles = {
    textContent: {
        marginBottom: "5px",
    },
    key: {
        fontWeight: "bold",
        color: "#333",
        minWidth: "80px", // 可以縮小 key 的寬度
        whiteSpace: "nowrap", // 避免 key 自動換行
    },
    value: {
        fontWeight: 500,
        color: "#007bff",
        wordBreak: "break-all", // 長度過長時，自動換行
        display: "block",
    },
};

class OrderDetailList extends PureComponent {
    constructor(props) {
        super(props);
    }

    doRender = () => {
        return (
            <div className="container">
            {this.props.details.map((item, index) => (
                <div key={index} className="row d-flex align-items-center" style={styles.textContent}>
                    <div className="col-auto text-left d-flex">
                        <span style={styles.key}>{item.label}</span>
                    </div>
                    <div className="col text-left flex-grow-1">
                        <span style={styles.value}>{item.value}</span>
                    </div>
                </div>
            ))}
        </div>
        );
    };

    render() {
        return (
            <div>
                {this.doRender()}
            </div>
        );
    }
}

export default hoistStatics(withTranslation()(OrderDetailList), OrderDetailList);
